import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: nowrap;
  min-height: 100vh;
  color: var(--primary);
  background-color: var(--secondary);
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  width:100%;
  border: 1px solid var(--primary);
  border-radius: 2rem;
  padding: 2rem 3rem;
  margin: 1rem 0;
`;

export const Question = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  width:100%;
  padding: 1rem 2rem;
`;

export const Choices = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  width:100%;
  padding: 1rem 2rem;
`;

export const ImgContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width:100%;
  @media (max-width: 600px) {
  }
  @media (max-width: 768px) {
  }
  @media (max-width: 992px) {
    flex-direction: column;
  }
  @media (max-width: 1200px) {
  }
`;

export const ImgBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width:100%;
  max-height:50rem;
  padding: 1rem 1rem;
  img{
    width:100%;
    height:100%;
    object-fit: contain;
  }
`;

export const Table = styled.table`
  width: 100%;
  border: 1px solid  var(--primary);
  padding: 1rem;
  table-layout: fixed;
  border-collapse: collapse;
  td:nth-child(even), th:nth-child(even){
    background-color: #f2f2f2;
  }
  td,th{
    border-bottom: 1px solid var(--primary);
    padding: 0.5rem;
    line-height: 2rem;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width:100%;
  gap: 2rem;
`;